"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AcceptOrganizationInviteDto = exports.UpdateUserRoleInOrganizationDto = exports.InviteUserToOrganizationDto = void 0;
const class_validator_1 = require("class-validator");
const organization_type_1 = require("../../types/organization.type");
class InviteUserToOrganizationDto {
    email;
    role;
    message;
}
exports.InviteUserToOrganizationDto = InviteUserToOrganizationDto;
__decorate([
    (0, class_validator_1.IsEmail)(),
    __metadata("design:type", String)
], InviteUserToOrganizationDto.prototype, "email", void 0);
__decorate([
    (0, class_validator_1.IsEnum)(organization_type_1.OrganizationRole),
    __metadata("design:type", String)
], InviteUserToOrganizationDto.prototype, "role", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], InviteUserToOrganizationDto.prototype, "message", void 0);
class UpdateUserRoleInOrganizationDto {
    userId;
    role;
}
exports.UpdateUserRoleInOrganizationDto = UpdateUserRoleInOrganizationDto;
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], UpdateUserRoleInOrganizationDto.prototype, "userId", void 0);
__decorate([
    (0, class_validator_1.IsEnum)(organization_type_1.OrganizationRole),
    __metadata("design:type", String)
], UpdateUserRoleInOrganizationDto.prototype, "role", void 0);
class AcceptOrganizationInviteDto {
    token;
}
exports.AcceptOrganizationInviteDto = AcceptOrganizationInviteDto;
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], AcceptOrganizationInviteDto.prototype, "token", void 0);
